import { render, staticRenderFns } from "./HazteSocioView.vue?vue&type=template&id=52037152&scoped=true&"
import script from "./HazteSocioView.vue?vue&type=script&lang=ts&"
export * from "./HazteSocioView.vue?vue&type=script&lang=ts&"
import style0 from "./HazteSocioView.vue?vue&type=style&index=0&id=52037152&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52037152",
  null
  
)

export default component.exports